export const environment = {
	production: false,
	apiHost: 'https://xxdz1s4aw1.execute-api.ap-south-1.amazonaws.com/Prod'
};


// xxdz1s4aw1  => is the API Gateway ID for Dev environment.